var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClipboard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_4c56a5a140bfd45f7b3e87d7ce6237e4",
    "data-name": "4c56a5a140bfd45f7b3e87d7ce6237e4",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_19984",
    "data-name": "Path 19984",
    d: "M1.5,32h25A1.451,1.451,0,0,0,28,30.5V2.5A1.451,1.451,0,0,0,26.5,1h-4a.5.5,0,0,0,0,1h4a.46.46,0,0,1,.5.5v28a.46.46,0,0,1-.5.5H1.5a.46.46,0,0,1-.5-.5V2.5A.46.46,0,0,1,1.5,2h4a.5.5,0,0,0,0-1h-4A1.451,1.451,0,0,0,0,2.5v28A1.451,1.451,0,0,0,1.5,32Z",
    fill: "#eef1f3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_19985",
    "data-name": "Path 19985",
    d: "M5.5,5a.5.5,0,0,0,0-1h-2a.5.5,0,0,0-.5.5v24a.5.5,0,0,0,.5.5h21a.5.5,0,0,0,.5-.5V4.5a.5.5,0,0,0-.5-.5h-2a.5.5,0,0,0,0,1H24V28H4V5Z",
    fill: "#eef1f3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_19986",
    "data-name": "Path 19986",
    d: "M9,7H19a1.874,1.874,0,0,0,2-2V.5a.5.5,0,0,0-.5-.5H7.5A.5.5,0,0,0,7,.5V5A1.874,1.874,0,0,0,9,7ZM8,1H20V5a.886.886,0,0,1-1,1H9A.886.886,0,0,1,8,5Zm.5,15h11a.5.5,0,0,0,0-1H8.5a.5.5,0,0,0,0,1Zm0-4h11a.5.5,0,0,0,0-1H8.5a.5.5,0,0,0,0,1Zm0,8h11a.5.5,0,0,0,0-1H8.5a.5.5,0,0,0,0,1Zm0,4h11a.5.5,0,0,0,0-1H8.5a.5.5,0,0,0,0,1Z",
    fill: "#eef1f3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboard);
export default __webpack_public_path__ + "static/media/clipboard.5705b9b2af2c8c0306a601aa2a9ed280.svg";
export { ForwardRef as ReactComponent };